module.exports = __webpack_public_path__ + "img/main-logo-green.00bc6d0a.svg";